import { FC, Suspense, lazy } from "react";
import { TestimonalConfig, Testimonial } from "./testimonials.types";
import { WidgetProps, WidgetType } from "@commons-monorepo/index";

const Testimonials1 = lazy(() => import("./skins/testimonials-1/testimonials-1"));
const Testimonials2 = lazy(() => import("./skins/testimonials-2/testimonials-2"));

const Testimonials: FC<WidgetProps<Testimonial[], TestimonalConfig>> = ({
  id,
  config,
  data: testimonials,
  type,
  theme,
  storeMetadata,
}) => {
  return testimonials?.length ? (
    <div id={id}>
      <Suspense>
        {type === WidgetType.TESTIMONIALS_2 && (
          <Testimonials2
            testimonials={testimonials}
            theme={theme}
            storeMetadata={storeMetadata}
            config={config}
          />
        )}
        {type === WidgetType.TESTIMONIALS_1 && (
          <Testimonials1
            testimonials={testimonials}
            theme={theme}
            storeMetadata={storeMetadata}
            config={config}
          />
        )}
      </Suspense>
    </div>
  ) : null;
};

export default Testimonials;
